

















import Vue from 'vue';
import _ from 'lodash';
const SIZE_CSS_CLASS = {
    big: 'btn-ims--big',
    small: 'btn-ims--small',
};

export default Vue.extend({
    props: {
        title: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'big',
            validator: value => {
                return _.includes(_.keys(SIZE_CSS_CLASS), value);
            },
        },
        type: {
            type: String,
            default: 'button',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            SIZE_CSS_CLASS,
        };
    },
});
